// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header_box[data-v-04fd8d87]{display:flex;justify-content:space-between}.dialog_form[data-v-04fd8d87]{width:500px}", ""]);
// Exports
module.exports = exports;
